export const DELIMITER = '*****'
